
const SearchFormFallback = () => {
  return (
    <div className="flex flex-col items-center gap-1 lg:grid lg:grid-cols-[4fr_2fr_2fr_1fr] lg:bg-grey50 lg:mt-1 mb-1 lg:px-4 lg:py-3 lg:rounded-[60px] lg:h-[77px]">
      <div className="flex items-center gap-3 lg:gap-4 psuedo-border-after bg-grey50 px-4 lg:pl-1 rounded-3xl w-full h-[47px]">
        <img
          src="/images/Icons/location-blue.svg"
          alt="Område"
          className="w-5 h-auto grayscale"
        />
        <div className="flex flex-col w-full">
          <span className="lg:flex items-center hidden rounded-md w-28 font-ic text-grey200 text-sm">
            Vart vill du bo?
          </span>
          <span className="py-1 rounded-md w-full font-ic text-grey200 text-sm lg:text-base">
            Sök efter kommun, län, område eller adress
          </span>
        </div>
      </div>
      <div className="flex items-center gap-3 lg:gap-4 bg-grey50 px-4 rounded-3xl w-full h-[47px]">
        <img
          src="/images/Icons/SearchStartPage/estate-type-icon.svg"
          alt="Bostadstyp"
          className="w-5 h-auto grayscale"
        />
        <div className="flex flex-col w-full">
          <span className="lg:block hidden font-ic text-grey200 text-sm">
            Hur vill du bo?
          </span>
          <span className="flex justify-between lg:hidden py-1 rounded-md w-full text-grey200 text-sm">
            Hur vill du bo?
            <img
              className="w-[10px] h-auto transition-all duration-75"
              src="/images/Icons/Arrows/arrow-down-simple-black500.svg"
              alt="pil"
            />
          </span>
          <span className="lg:flex lg:gap-4 hidden py-1 rounded-md w-full text-base text-grey200">
            Välj bostadstyp
            <img
              className="w-[10px] h-auto transition-all duration-75"
              src="/images/Icons/Arrows/arrow-down-simple-black500.svg"
              alt="pil"
            />
          </span>
        </div>
      </div>
      <div className="relative lg:before:top-1/2 lg:before:-left-[18px] lg:before:absolute flex items-center lg:before:content-[''] gap-3 lg:gap-4 bg-grey50 lg:before:bg-grey100 px-4 rounded-3xl w-full lg:before:w-[1px] h-[47px] lg:before:h-5/6 lg:before:-translate-y-1/2">
        <img
          src="/images/Icons/SearchStartPage/room-icon.svg"
          alt="Antal rum"
          className="w-5 h-auto grayscale"
        />
        <div className="flex flex-col w-full">
          <span className="lg:block hidden font-ic text-grey200 text-sm">
            Minst antal rum
          </span>
          <span className="flex justify-between lg:hidden py-1 rounded-md w-full text-grey200 text-sm">
            Minst antal rum
            <img
              className="w-[10px] h-auto transition-all duration-75"
              src="/images/Icons/Arrows/arrow-down-simple-black500.svg"
              alt="pil"
            />
          </span>
          <span className="lg:flex lg:gap-4 hidden py-1 rounded-md w-full text-base text-grey200">
            Välj antal rum
            <img
              className="w-[10px] h-auto transition-all duration-75"
              src="/images/Icons/Arrows/arrow-down-simple-black500.svg"
              alt="pil"
            />
          </span>
        </div>
      </div>

      <div className="flex justify-center items-center bg-grey300 mt-1 lg:mt-0 rounded-3xl w-full h-[44px]">
        <span className="font-icb text-white">Sök</span>
        <img
          width="16"
          height="16"
          className="ml-3 w-4"
          src="/Images/Icons/search-icon.svg"
          alt="Sök"
        />
      </div>
    </div>
  );
};

export default SearchFormFallback;
